/* eslint-disable no-nested-ternary */
/* eslint-disable react/button-has-type */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/prop-types */
/* eslint-disable no-shadow */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Button, ButtonToolbar, Label, Input, Row, FormGroup, Modal, FormFeedback } from 'reactstrap';
import { toLower, map, concat, some } from 'lodash';
import PropTypes from 'prop-types';
import Select from 'react-select';
import RUTJS from 'rutjs';

import { getSignature, uploadAvatar, getUsers, createUser, updateUser, deleteUser, } from '../../redux/actions/userActions';
import { getRoles } from '../../redux/actions/resourcesActions';
import { getAllSubTypesCases } from '../../redux/actions/casesActions';
import { getConcessionaires } from '../../redux/actions/quotationsActions';
import { rolesFormatter } from '../../helper/functions';
import { ROLES } from '../../helper/constants';
import BasicNotification from './Notifications/BasicNotification';
import avatarDefault from '../img/avatar-default.jpg';

const maxTrinidadCode = 99999;

const excludingOptions = [
  { DeaCodigoDealer: '100001', DeaNombre: '100001 Todos' },
  { DeaCodigoDealer: '100002', DeaNombre: '100002 Ninguno' }
];
const all = [{ value: '100001', label: 'Todos' }];
const none = [{ value: '100002', label: 'Ninguno' }];

const isRoleSelected = (roles, role) => some(roles, e => e.value === role);
const invalidCode = (value) => value && (value > maxTrinidadCode || value < 1);

class ModalComponent extends Component {
  static defaultProps = {
    title: ''
  };

  constructor() {
    super();
    this.state = {
      _id: null,
      modal: false,
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      passInvalid: false,
      anexo: '',
      denwaPassword: '',
      rut: '',
      rolesOptions: [],
      roles: [],
      avatar: '',
      status: true,
      subtypeOptions: [],
      subtype: [],
      cesSelected: all,
      spiderSelected: none,
      trinidadCode: 0
    };
    this.inputFile = React.createRef();
  }

  componentDidMount() {
    this.props.getRoles({ all: true }, (body) => {
      this.setState({ rolesOptions: map(body, role => ({ value: role, label: rolesFormatter(role) })) });
    });
    this.props.getAllSubTypesCases({ limit: 100 }, (body) => {
      this.setState({ subtypeOptions: map(body, subtype => ({ value: subtype._id, label: subtype.name })) });
    });

    this.getSalesExecutiveData();
  }

  getSalesExecutiveData = async () => {
    await this.props.getConcessionaires();
  }

  toggle = isOk => () => {
    this.setState({ modal: false, trinidadCode: 0 });
    if (this.props.onClose) {
      this.props.onClose(isOk);
    }
  }

  findRol = () => some(this.state.roles, (e) => e.value === ROLES.salesExecutive);

  onChangeInput = key => (e) => {
    if (key === 'password') {
      this.setState({ passInvalid: e.target.value && !this.validatePass(e.target.value), password: e.target.value });
    } else if (key === 'status') {
      this.setState({ status: e && e.value === 'true' });
    } else if (key === 'avatar' || key === 'subtype') {
      this.setState({ [key]: e });
    } else if (key === 'trinidadCode') {
      this.setState({ [key]: e.target.value.replace(/\D/g, '') });
    } else if (key === 'roles') {
      if (!some(e, (roles) => roles.value === ROLES.salesExecutiveSc)) {
        this.setState({ trinidadCode: 0 });
      }
      this.setState({ [key]: e });
      if (!some(e, item => item.value === ROLES.salesExecutive || item.value === ROLES.decExecutivePort)) {
        this.setState({ spiderSelected: none, cesSelected: none });
      }
    } else if (key === 'email') {
      this.setState({ [key]: toLower(e.target.value) });
    } else if (key === 'anexo') {
      const justNumbers = e.target.value.replace(/[^0-9\s]/gi, '').trim();
      this.setState({ [key]: justNumbers });
    } else if (key === 'spiderSelected' || key === 'cesSelected') {
      this.setState({ [key]: e });
      this.handleAll(e, key);
    } else {
      this.setState({ [key]: e.target.value });
    }
  }

  handleAll = (e, key) => {
    if (some(e, item => item.value === '100001')) this.setState({ [key]: all });
    if (some(e, item => item.value === '100002')) this.setState({ [key]: none });
  }

  // eslint-disable-next-line no-useless-escape
  validatePass = (value) => (/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()+=-\?;,./{}|\":<>\[\]\\\' ~_]).{8,}/.test(value));

  onChangeImg = () => {
    if (this.inputFile) {
      this.inputFile.current.click();
    }
  }

  onChangeInputFile = (event) => {
    this.renderFile(event.target.files[0], (image) => {
      this.onChangeInput('avatar')(image);
    });
  }

  renderFile = (file, callback) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const photo = {
        file,
        temp: event.target.result,
      };
      callback(photo);
    };
    reader.onerror = () => {
      BasicNotification.show({
        color: 'danger',
        title: 'Atención',
        message: `Ocurrio un error al intentar cargar la imágen ${file.name}`,
      });
    };
    reader.readAsDataURL(file);
  }

  getSrc = (avatar) => {
    if (avatar) {
      if (typeof avatar === 'string') {
        return avatar;
      }

      if (avatar.temp) {
        return avatar.temp;
      }
    }
    return avatarDefault;
  }

  isRUTValid = (rut) => {
    if (!rut) return true;
    return (new RUTJS(rut)).isValid;
  }

  onSubmit = (e) => {
    e.preventDefault();
    const {
      _id,
      firstName,
      lastName,
      email,
      password,
      anexo,
      denwaPassword,
      rut,
      roles,
      avatar,
      status,
      subtype,
      cesSelected,
      spiderSelected,
      trinidadCode,
    } = this.state;

    if (!this.isRUTValid(rut)) {
      BasicNotification.show({
        color: 'danger',
        title: 'Atención',
        message: 'Debe ingresar un RUT válido.',
      });
      return;
    }

    if (!_id && password.length < 8) {
      BasicNotification.show({
        color: 'danger',
        title: 'Atención',
        message: 'Debe ingresar una contraseña con mínimo 8 caracteres.',
      });
      return;
    }

    if (!_id && roles.length === 0) {
      BasicNotification.show({
        color: 'danger',
        title: 'Atención',
        message: 'Se debe ingresar al menos un rol.',
      });
      return;
    }

    let subtypeList = [];
    if (subtype.length > 0) {
      subtypeList = map(subtype, type => ({ _id: type.value, name: type.label }));
    }

    let dataToSend = {
      _id,
      firstName: firstName.trim(),
      lastName: lastName.trim(),
      email: email.trim(),
      password,
      anexo,
      denwaPassword,
      rut,
      roles: this.resolveRoles(roles),
      avatar,
      status,
      subtype: subtypeList,
      trinidadCode: isRoleSelected(roles, ROLES.salesExecutiveSc) ? parseInt(trinidadCode) : 0,
      spider_dealers: spiderSelected.length > 0 ? map(spiderSelected, (e) => ({ code: parseInt(e.value), name: e.label })) : [{ code: '100002', name: 'Ninguno' }],
      web_dealers: cesSelected.length > 0 ? map(cesSelected, (e) => ({ code: parseInt(e.value), name: e.label })) : [{ code: '100002', name: 'Ninguno' }],
    }

    if (avatar.file) {
      this.props.getSignature(avatar.file.name, (body) => {
        this.props.uploadAvatar({ ...body, file: avatar.file }, (data) => {
          this.sendData({ ...dataToSend, avatar: data.secure_url });
        });
      });

    } else {
      this.sendData(dataToSend);
    }
  }

  resolveRoles = roles => map(roles || [], rol => rol.value || rol)

  sendData = (data) => {
    if (!data._id) {
      delete data._id;
      this.props.createUser(data, () => {
        this.toggle(true)();
        this.setState({ trinidadCode: 0 });
      });
    } else {
      this.props.updateUser(data._id, data, () => {
        this.toggle(true)();
        this.setState({ trinidadCode: 0 });
      });
    }
  }

  showModal = () => {
    this.setState({ modal: true });
  }

  translateRoles = roles => roles.map(rol => ({ value: rol, label: rolesFormatter(rol) }));

  setData = (data) => {
    this.setState({
      ...data,
      roles: this.translateRoles(data.roles),
      cesSelected: map(data.web_dealers, (e) => ({ value: `${e.code}`, label: e.name })),
      spiderSelected: map(data.spider_dealers, (e) => ({ value: `${e.code}`, label: e.name })),
    });
  }

  render() {
    const {
      modal,
      firstName,
      lastName,
      email,
      password,
      anexo,
      denwaPassword,
      rut,
      roles,
      avatar,
      status,
      subtype,
      trinidadCode,
    } = this.state;
    const statusOptions = [
      { value: 'true', label: 'Activo' },
      { value: 'false', label: 'Inactivo' },
    ];
    const statusSelected = status === true ? statusOptions[0] : statusOptions[1];
    const concessionaries = map(concat(excludingOptions, this.props.concessionaires), e => (
      { value: `${e.DeaCodigoDealer}`, label: `${e.DeaNombre.substr(e.DeaNombre.indexOf(' ') + 1)}` }
    ));
    return (
      <div>
        <Modal
          isOpen={modal || this.props.isOpen}
          toggle={this.toggle()}
          className="modal-dialog modal-dialog--header"
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" onClick={this.toggle()} />
            <h2 className="bold-text label_autofin  modal__title"> <strong>{this.props.title}</strong></h2>
          </div>
          <div className="modal__body crm-modal-body-container">
            <Col md={12} lg={12}>
              <form className="form form--horizontal" autoComplete="off" onSubmit={this.onSubmit}>
                <Row className="row_center">
                  <div className="everlast">
                    <div>
                      <Col md="12">
                        <FormGroup className="crm-modal-avatar-container">
                          <Label className="label_autofin" for="avatar">Foto perfil:</Label>
                          <img src={this.getSrc(avatar)} alt="avatar" />
                          <FormGroup className="element_center_file">
                            <Button
                              className="asignar"
                              onClick={this.onChangeImg}
                            >Cambiar
                            </Button>
                            <input
                              type="file"
                              ref={this.inputFile}
                              onChange={this.onChangeInputFile}
                              hidden
                            />
                          </FormGroup>
                          <div className='pass-rules-modal'>
                            <span>La contraseña debe tener al menos:</span>
                            <p >• 8 caracteres.</p>
                            <p >• Una letra mayúscula.</p>
                            <p >• Una letra minúscula.</p>
                            <p >• Un número.</p>
                            <p >• Un carácter especial (Ejemplo: .,#$%&-+).</p>
                          </div>
                        </FormGroup>
                      </Col>
                    </div>
                    <div className='crm-modal-edit-user'>
                      <Row>
                        <Col md="6">
                          <FormGroup className="form__form-group-input">
                            <Label className="label_autofin" for="firstName">Nombre:</Label>
                            <Input
                              // className="new_size"
                              type="text"
                              name="firstName"
                              id="firstName"
                              value={firstName}
                              onChange={this.onChangeInput('firstName')}
                              maxLength='100'
                              required
                            />
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup>
                            <Label className="label_autofin" for="lastName">Apellido:</Label>
                            <Input
                              // className="new_size"
                              type="text"
                              name="lastName"
                              id="lastName"
                              value={lastName}
                              onChange={this.onChangeInput('lastName')}
                              maxLength='100'
                              required
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="6">
                          <FormGroup>
                            <Label className="label_autofin" for="email">Email:</Label>
                            <Input
                              // className="new_size"
                              type="email"
                              autocomplete='off'
                              // name="email"
                              // id="email"
                              value={email}
                              onChange={this.onChangeInput('email')}
                              maxLength='100'
                              required
                            />
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup>
                            <Label className="label_autofin" for="password">Contraseña:</Label>
                            <Input
                              // className="new_size"
                              autocomplete='off'
                              type="password"
                              // name="password"
                              // id="password"
                              value={password}
                              // disabled={!_id}
                              maxLength='100'
                              onChange={this.onChangeInput('password')}
                            />
                            {this.state.passInvalid && <p className='pass-invalid'>¡Contraseña no cumple las reglas de seguridad!</p>}
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="6">
                          <FormGroup>
                            <Label className="label_autofin" for="rut">Rut:</Label>
                            <Input
                              type="text"
                              name="rut"
                              id="rut"
                              value={rut}
                              onChange={this.onChangeInput('rut')}
                              invalid={!this.isRUTValid(rut)}
                              maxLength='100'
                              required
                            />
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <div className={`${isRoleSelected(roles, ROLES.salesExecutiveSc) && 'crm-form-double'}`}>
                            {isRoleSelected(roles, ROLES.salesExecutiveSc) && <FormGroup>
                              <Label className="label_autofin" for="trinidad-code">Cod. Trinidad:</Label>
                              <Input
                                // type="number"
                                name="trinidad-code"
                                id="trinidad-code"
                                autocomplete="off"
                                value={trinidadCode}
                                onChange={this.onChangeInput('trinidadCode')}
                                required={isRoleSelected(roles, ROLES.salesExecutiveSc)}
                                maxLength={5}
                                invalid={invalidCode(trinidadCode)}
                              />
                              <FormFeedback>El código trindidad debe estar entre 1 y {`${maxTrinidadCode}`}</FormFeedback>
                            </FormGroup>}
                            <FormGroup>
                              <Label className="label_autofin" for="anexo">Anexo:</Label>
                              <Input
                                type="text"
                                // name="anexo"
                                // id="anexo"
                                autocomplete="off"
                                value={anexo}
                                onChange={this.onChangeInput('anexo')}
                                required
                                maxLength='20'
                              />
                            </FormGroup>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="6">
                          <FormGroup>
                            <Label className="label_autofin" for="denwaPassword">Contraseña Denwa:</Label>
                            <Input
                              type="password"
                              autocomplete="off"
                              name="denwaPassword"
                              id="denwaPassword"
                              value={denwaPassword}
                              onChange={this.onChangeInput('denwaPassword')}
                              maxLength='100'
                            />
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup>
                            <Label className="label_autofin" for="role">Estado:</Label>
                            <Select
                              onChange={this.onChangeInput('status')}
                              options={statusOptions}
                              value={statusSelected}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      {this.findRol() &&
                        <Row>
                          <Col md="6">
                            <FormGroup>
                              <Label className="label_autofin" for="dealer">CES:</Label>
                              <Select
                                name='cesSelected'
                                className="autoHeightSelect"
                                onChange={this.onChangeInput('cesSelected')}
                                options={concessionaries}
                                value={this.state.cesSelected}
                                isMulti
                                placeholder="seleccione uno o varios"
                                isClearable={true}
                              />
                            </FormGroup>
                          </Col>
                          <Col md="6">
                            <FormGroup>
                              <Label className="label_autofin" for="origin">Spider:</Label>
                              <Select
                                name='spiderSelected'
                                className="autoHeightSelect"
                                onChange={this.onChangeInput('spiderSelected')}
                                options={concessionaries}
                                isMulti
                                value={this.state.spiderSelected}
                                placeholder="seleccione uno o varios"
                                isClearable={true}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      }
                      <Row>
                        <Col md="6">
                          <FormGroup>
                            <Label className="label_autofin" for="subtype">Habilidades:</Label>
                            <Select
                              className="autoHeightSelect"
                              onChange={this.onChangeInput('subtype')}
                              options={this.state.subtypeOptions}
                              isMulti={this.state.subtypeOptions}
                              value={subtype}
                            />
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup>
                            <Label className="label_autofin" for="role">Roles:</Label>
                            <Select
                              className="autoHeightSelect"
                              onChange={this.onChangeInput('roles')}
                              options={this.state.rolesOptions}
                              isMulti={this.state.rolesOptions}
                              value={roles}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </Row>
                <ButtonToolbar className="modal__footer">
                  <Button className="asignar" onClick={this.toggle()}>Cancelar</Button>{' '}
                  <Button
                    className="asignar just_this"
                    type="submit"
                    id="added"
                    disabled={this.state.passInvalid || !roles}
                  >Guardar
                  </Button>
                  <Button
                    className="btn black_resize_button account__btn account__btn--small"
                    id="loader"
                    type="button"
                    style={{ display: 'none' }}
                    disabled
                  />
                </ButtonToolbar>
              </form>
            </Col>
          </div>
        </Modal>
      </div>
    );
  }
}

ModalComponent.propTypes = {
  getAllSubTypesCases: PropTypes.func.isRequired,
  getConcessionaires: PropTypes.func.isRequired,
  getRoles: PropTypes.func.isRequired,
  getSignature: PropTypes.func,
  uploadAvatar: PropTypes.func,
  updateUser: PropTypes.func,
  createUser: PropTypes.func,
  concessionaires: PropTypes.array,
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
  title: PropTypes.string,
};

const mapStateToProps = ({ quotations }) => ({
  concessionaires: quotations.ces
});

const mapDispatchToProps = {
  getSignature,
  uploadAvatar,
  getUsers,
  createUser,
  updateUser,
  deleteUser,
  getRoles,
  getAllSubTypesCases,
  getConcessionaires,
};

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(ModalComponent);
